import React from 'react';
import { filter, orderBy } from 'lodash';
import enhance from './MyCampaigns.enhancer';
import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import { dealStatuses } from '../../../constants';
import Box from '@material-ui/core/Box';
import { campaignStatuses } from '../../../constants';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import DoneIcon from '@material-ui/icons/Done';
import ScheduleIcon from '@material-ui/icons/Schedule';
import LinkText from '../../../components/shared/components/LinkText';

class MyCampaigns extends React.Component {
  constructor() {
    super();

    const initialState = {
      campaignRows: [],
      loadComplete: false
    };

    this.state = {
      ...initialState
    };
  }

  componentDidMount() {
    if (
      !this.state.loadComplete &&
      typeof this.props.campaigns !== 'undefined' &&
      typeof this.props.deals !== 'undefined'
    ) {
      this.loadData(this.props.campaigns, this.props.deals);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      !this.state.loadComplete &&
      typeof nextProps.campaigns !== 'undefined' &&
      typeof nextProps.deals !== 'undefined'
    ) {
      this.loadData(nextProps.campaigns, nextProps.deals);
    }
  }

  loadData(campaigns, deals) {
    let campaignRows = [];
    if (campaigns && campaigns.length) {
      campaignRows = campaigns.map(campaign => {
        const createdDate = moment(campaign.createdAt.toDate()).format(
          'MM/DD/YYYY'
        );
        const campaignDeals = filter(
          deals,
          deal => deal.campaignId === campaign.id
        );
        if (campaignDeals.length) {
          return {
            ...campaign,
            createdDate,
            totalInterest: filter(
              campaignDeals,
              deal =>
                !(
                  deal.status === dealStatuses.OFFER &&
                  deal.initiator === 'company'
                )
            ).length,
            activeDealsCount: filter(
              campaignDeals,
              deal => deal.status === dealStatuses.ACTIVE
            ).length,
            completeDealsCount: filter(
              campaignDeals,
              deal => deal.status === dealStatuses.COMPLETE
            ).length
          };
        } else {
          return {
            ...campaign,
            createdDate,
            totalInterest: 0,
            activeDealsCount: 0,
            completeDealsCount: 0
          };
        }
      });
    }
    this.setState({
      loadComplete: true,
      campaignRows: orderBy(campaignRows, ['createdAt'], ['desc'])
    });
  }

  handleCampaignClick(campaignId) {
    this.props.history.push(`/campaigns/${campaignId}`);
  }

  navigateToCreateCampaign() {
    this.props.history.push(`/campaign/new`);
  }

  render() {
    const { campaignRows, loadComplete } = this.state;
    const { classes } = this.props;

    return (
      <React.Fragment>
        <main className={classes.layout}>
          <Paper className={classes.root}>
            {campaignRows &&
              loadComplete &&
              campaignRows.length > 0 &&
              campaignRows.map(row => (
                <Grid
                  key={row.id}
                  className={classes.listRow}
                  container
                  direction="row"
                >
                  <Grid item sm={3}>
                    <Grid container direction="column">
                      <Grid item>
                        <Typography variant="h6">{row.name}</Typography>
                      </Grid>
                      <Grid item>
                        <Typography color="text.secondary">
                          <Box color="text.secondary">
                            Posted on {row.createdDate}
                          </Box>
                        </Typography>
                      </Grid>
                      <Grid item>
                        {row.status === campaignStatuses.ACTIVE && (
                          <Typography>
                            <AssignmentTurnedInIcon
                              className={classes.dealStatusIcon}
                            />
                            Active
                          </Typography>
                        )}
                        {row.status === campaignStatuses.RETIRED && (
                          <Typography>
                            <DoneIcon className={classes.dealStatusIcon} />
                            Retired
                          </Typography>
                        )}
                        {row.status === campaignStatuses.PENDING && (
                          <Typography>
                            <ScheduleIcon className={classes.dealStatusIcon} />
                            Pending
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item sm={2}>
                    <Typography variant="h6">{row.totalInterest}</Typography>
                    <Typography>Total Interest</Typography>
                  </Grid>
                  <Grid item sm={2}>
                    <Typography variant="h6">{row.activeDealsCount}</Typography>
                    <Typography>Active Deals</Typography>
                  </Grid>
                  <Grid item sm={2}>
                    <Typography variant="h6">
                      {row.completeDealsCount}
                    </Typography>
                    <Typography>Completed Deals</Typography>
                  </Grid>
                  <Grid item sm={3}>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.detailsButton}
                      onClick={() => this.handleCampaignClick(row.id)}
                    >
                      Campaign Details
                    </Button>
                  </Grid>
                </Grid>
              ))}
            {loadComplete && (!campaignRows || campaignRows.length <= 0) && (
              <Typography
                variant="h6"
                align="center"
                justify="center"
                className={classes.noCampText}
              >
                No campaigns yet -
                <LinkText
                  className={classes.createCampLink}
                  onClick={() => this.navigateToCreateCampaign()}
                >
                  Create Campaign
                </LinkText>
              </Typography>
            )}
          </Paper>
        </main>
      </React.Fragment>
    );
  }
}

export default enhance(MyCampaigns);



// WEBPACK FOOTER //
// ./src/components/company/my-campaigns/MyCampaigns.js